define([
    'jquery',
    'scanTranslations',
    'word-and-character-count'
], function ($, scanTranslations) {
    $("textarea.character-count").each(function(index, elem) {
        var $elem = $(elem);

        if ($elem.attr('maxlength')) {
            var maxLength = parseInt($elem.attr('maxlength'));
            var count = 'down';
            var append = true;
            var type = 'char';

            if ($elem.attr('data-scan-count')) {
                count = $elem.attr('data-scan-count');
            }
            if ($elem.attr('data-scan-append')) {
                append = ($elem.attr('data-scan-append') === 'true');
            }
            if ($elem.attr('data-scan-type')) {
                type = $elem.attr('data-scan-type');
            }

            // see http://qwertypants.github.io/jQuery-Word-and-Character-Counter-Plugin/ for details on options available
            if (!isNaN(maxLength)) {
                scanTranslations.getInstance().then(function (scanTranslationInstance) {
                    $elem.counter({
                        count: count,
                        append: append,
                        type: type,
                        goal: maxLength,
                        translation: scanTranslationInstance.translate("character_count_remaining")
                    });
                });
            }
        }
    });
});
